import React, { useEffect } from 'react';
import { Dialog, ElevatedButton, TextButton } from '@producer/ui-kit';

import { PlanCardCheckOn } from '../icons';
import { api } from '../../api';
import { context } from '../../app/context';

import styles from './limit-reached.modal.module.scss';

interface LimitReachedModalProps {
  /**
   * @deprecated
   */
  type?: 'projects' | 'creators' | 'shots';

  /**
   * Title to replace type
   */
  title?: string;

  onCancel: () => void;

  /**
   * If an event should be tracked when seeing the modal.
   * Should be the name of an event on Active Campaign
   */
  eventName?: string;
}

export const LimitReachedModal: React.FC<LimitReachedModalProps> = ({
  type,
  title,
  onCancel,
  eventName,
}) => {
  const spaceId = context.space._id;

  /* TODO: Uncomment this when we have a way to track events on the client side
  useEffect(() => {
    if (!eventName) {
      return;
    }

    api.post('/track', { type: 'event', eventName });
  }, [eventName]);
  */

  const dialogActions = [
    <TextButton key="keep-current-plan" onClick={onCancel} text="Keep current plan" />,
    <ElevatedButton
      key="upgrade-plan"
      onClick={() => {
        onCancel();
        context.navigate(`/space/${spaceId}/settings/plans`);
      }}
      text="View plans"
    />,
  ];

  const header = title
    ? title
    : `We are happy to see you grow, upgrade to create unlimited ${type}`;

  return (
    <Dialog onClose={onCancel} actions={dialogActions}>
      <div className={styles['container']}>
        <div className={styles['header-with-image']}>
          <h3>{header}</h3>
        </div>

        <div className={styles['content']}>
          <span>By upgrading, you get:</span>
          <ul className={styles['features-list']}>
            {[
              'Unlimited projects',
              'Extra storage',
              'Extra seats',
              'Unlimited number of shots',
              'Export to PDF',
            ].map((feature) => (
              <li key={feature}>
                <PlanCardCheckOn />
                <span>{feature}</span>
              </li>
            ))}
          </ul>
          <span>... and other epic features!</span>
        </div>
      </div>
    </Dialog>
  );
};
